import styled from 'styled-components';

import { Button } from 'components/button';
import { captionRegular } from 'styles/mixins/fonts';

export const DeleteFileButton = styled(Button)`
  margin-top: 16px;
`;

// BOOKING A2: the note over the payments a booking manages.
export const Note = styled.span`
  ${captionRegular};
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;

// Under the address while it is typed by hand (same place and size as a
// field error, grey).
export const AddressHint = styled.p`
  color: ${({ theme }) => theme.colors.grey.primary.standard};
`;
